<div class="container-fluid">
  <div class="wrapper">
    <div class="row align-items-center h-100">
      <div class="mx-auto">
        <div class="card p-4">
          <div class="d-flex justify-content-center">
            <div class="icon-block d-flex justify-content-center">
              <i class="pi pi-lock lock"> </i>
            </div>
          </div>
          <div class="text-center my-4">
            <div class="text-muted">
              {{
                verificationType === "SMS"
                  ? ("auth.sms-form-message" | translate)
                  : verificationType === "Email" ?  ("auth.email-form-message" | translate) : ("auth.authentication-form-message" | translate)
              }}
            </div>
          </div>
          <form [formGroup]="twoFactorForm">
            <div class="my-4 d-flex justify-content-center">
              <input
                formControlName="otp1"
                #otp1Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(1, $event)"
              />
              <input
                formControlName="otp2"
                #otp2Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(2, $event)"
              />
              <input
                formControlName="otp3"
                #otp3Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(3, $event)"
              />
              <input
                formControlName="otp4"
                #otp4Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(4, $event)"
              />
              <input
                formControlName="otp5"
                #otp5Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(5, $event)"
              />
              <input
                formControlName="otp6"
                #otp6Input
                type="text"
                class="form-control digit-otp"
                maxlength="1"
                (input)="onOtpChange(6, $event)"
              />
            </div>

            <button
              type="submit"
              class="btn btn-lg w-100 mt-3 mb-4 py-3"
              [ngClass]="btnStatus"
              [disabled]="!twoFactorForm.valid"
              (click)="verifyCode()"
            >
              {{ "auth.verify" | translate }}
            </button>

            <div
              class="d-grid justify-content-center"
              *ngIf="verificationType === 'SMS' || verificationType==='Email'"
            >
              <div class="timer text-center" *ngIf="timeLeft > 0">
                {{ "auth.left-timer" | translate }}: {{ formatTime(timeLeft) }}
              </div>
              <button
                *ngIf="timeLeft == 0"
                class="resend-button"
                (click)="resendCode()"
              >
                {{ "auth.resend-code" | translate }}
              </button>
            </div>
          </form>
          <span (click)="goBack()" role="button"  tabindex="-1"> 
            <i class="fa fa-arrow-left" ></i>
          </span>
          
        </div>
      </div>
    </div>
  </div>
</div>
